module.exports = __webpack_public_path__ + "static/media/venvi3.37f07947.gif";